import {
  DurationDiscount,
  FacilityLicenceSummary,
  LicencePlan,
  LicenceRequest,
  LicenceResponse,
} from "../types/licence.definition";
import {
  DoctorLicence,
  DoctorLicencePage,
  DoctorLicenceRequest,
  DoctorLicenceSummary,
} from "../types/doctorLicence.definition";
import {
  createLicence,
  getAllDoctorLicences,
  getAllFacilityLicences,
  getAvailableLicencePlans,
  getDurationDiscounts,
  getLicenceByFacility,
  pauseLicence,
  unpauseLicence,
  getDoctorLicence,
  pauseDoctorLicence,
  unpauseDoctorLicence,
  reactivateDoctorLicence,
  liftDoctorLicenceCancellation,
  expireDoctorLicence,
  getPendingDoctorLicenceRequests,
  approveDoctorLicenceRequest,
  rejectDoctorLicenceRequest,
} from "../webclients/licence.client";

export const licenceApi = {
  getAvailablePlans: async (): Promise<LicencePlan[]> => {
    const response = await getAvailableLicencePlans();
    return response.data;
  },

  getDurationDiscounts: async (): Promise<DurationDiscount[]> => {
    const response = await getDurationDiscounts();
    return response.data;
  },

  getLicenceByFacility: async (
    facilityId: number
  ): Promise<LicenceResponse> => {
    const response = await getLicenceByFacility(facilityId);
    return response.data;
  },

  createLicence: async (
    facilityId: number,
    data: LicenceRequest
  ): Promise<LicenceResponse> => {
    const response = await createLicence(facilityId, data);
    return response.data;
  },

  pauseLicence: async (
    facilityId: number,
    licenceId: number
  ): Promise<LicenceResponse> => {
    const response = await pauseLicence(facilityId, licenceId);
    return response.data;
  },

  unpauseLicence: async (
    facilityId: number,
    licenceId: number
  ): Promise<LicenceResponse> => {
    const response = await unpauseLicence(facilityId, licenceId);
    return response.data;
  },

  getDoctorLicence: async (doctorId: number): Promise<DoctorLicence> => {
    const response = await getDoctorLicence(doctorId);
    return response.data;
  },

  pauseDoctorLicence: async (
    doctorId: number,
    licenceId: number
  ): Promise<DoctorLicence> => {
    const response = await pauseDoctorLicence(doctorId, licenceId);
    return response.data;
  },

  unpauseDoctorLicence: async (
    doctorId: number,
    licenceId: number
  ): Promise<DoctorLicence> => {
    const response = await unpauseDoctorLicence(doctorId, licenceId);
    return response.data;
  },

  reactivateDoctorLicence: async (
    doctorId: number,
    licenceId: number
  ): Promise<DoctorLicence> => {
    const response = await reactivateDoctorLicence(doctorId, licenceId);
    return response.data;
  },

  liftDoctorLicenceCancellation: async (
    doctorId: number,
    licenceId: number,
    reason?: string
  ): Promise<DoctorLicence> => {
    const response = await liftDoctorLicenceCancellation(
      doctorId,
      licenceId,
      reason
    );
    return response.data;
  },

  getPendingDoctorLicenceRequests: async (): Promise<
    DoctorLicenceRequest[]
  > => {
    const response = await getPendingDoctorLicenceRequests();
    return response.data;
  },

  approveDoctorLicenceRequest: async (
    requestId: number
  ): Promise<DoctorLicence> => {
    const response = await approveDoctorLicenceRequest(requestId);
    return response.data;
  },

  rejectDoctorLicenceRequest: async (requestId: number): Promise<void> => {
    await rejectDoctorLicenceRequest(requestId);
  },

  getAllDoctorLicences: async (params: {
    status?: string;
    plan_type?: string;
    page?: number;
    size?: number;
  }): Promise<DoctorLicencePage> => {
    const response = await getAllDoctorLicences(params);
    return response.data;
  },

  expireDoctorLicence: async (
    doctorId: number,
    licenceId: number
  ): Promise<DoctorLicenceSummary> => {
    const response = await expireDoctorLicence(doctorId, licenceId);
    return response.data;
  },

  getAllFacilityLicences: async (): Promise<FacilityLicenceSummary[]> => {
    const response = await getAllFacilityLicences();
    return response.data;
  },
};
